<template>
<BootstrapDialog title="选择班主任" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <form role="form">
		                <div class="col-sm-12" style="padding-top: 10px;margin-bottom: 30px">
		                    <BootstrapTable class="boot_table text-nowrap" style="font-size: 14px;"
		                                    ref="table"
		                                    v-once
		                                    :columns="columns"
		                                    :options="{
		                                        undefinedText:'',
		                                        showColumns: false,
		                                        sidePagination:'server',
		                                        pagination:false,
		                                        pageNumber:1,
		                                        pageSize:10,
		                                        pageList:[10,50,100,500],
		                                        paginationPreText:'上一页',
		                                        paginationNextText:'下一页',
		                                        showExtendedPagination:true,
		                                        paginationLoop:false
		                         			}"
		                                    @onPostBody="vueFormatterPostBody"
		                    />
		                </div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-primary" type="button" @click="save()">保存</button>
		<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name:'BjFdyXz',
		components:{
		},
        data:function(){
            return {
				query:{
					
				},
                model:{
					bjId:'',
					ids:''
                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true,
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'xm',
                        title: '姓名'
                    },
                    {
                        field: 'sfzh',
                        title: '身份证号'
                    },
                ]
            }
        },
        methods:{
			reset:function(){
				this.model = {
					bjId:'',
					ids:''
				};
			},
			async open(params){
				this.model.bjId = params.bjId;
				let res =await this.$http.post('/htgl/sys/bj/hqjgfdy',this.query);
				if(res.data){
					let data = res.data;
					this.$refs.table.load(data);
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
			save:function(){
				let selections = this.$refs.table.getSelections();
				if(!selections || selections.length ==0){
					this.$error('请选择班主任');
					return;
				}
				let ids = selections.map(x=>x.id);
				if(!ids || ids.length == 0){
					this.$error('请选择班主任');
					return;
				}
				this.model.ids = ids.join(',');
				this.$validator.validateAll().then((result) => {
					if (result) {//如果表单校验通过才可以保存
						this.$http.post('/htgl/sys/bj/choosefdy',this.model).then(res=>{
							if(res.data==true){
								this.$success('操作成功',()=>{
									this.close();
									this.$parent.load();//刷新列表
								});
							}
						});
					}
				});
			}
        }
    }
</script>
